import { StyledLink } from 'Packages/FacetDesign/Components/Experimental/StyledLink';
import React from 'react';


export const LearnMoreHereLink = () => {
  return (<StyledLink href={'#disclosures'}>Learn more here</StyledLink>);
};
